/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconPhone16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPhone16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M9.334 4V2.667H6.667V4h2.667Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.334 5.2c0-1.746 0-2.618.393-3.26.22-.358.522-.66.88-.88C5.25.667 6.121.667 7.867.667h.267c1.746 0 2.619 0 3.26.393.359.22.66.522.88.88.393.642.393 1.514.393 3.26v5.6c0 1.746 0 2.62-.393 3.26-.22.36-.521.66-.88.88-.641.394-1.514.394-3.26.394h-.267c-1.746 0-2.618 0-3.26-.393a2.667 2.667 0 0 1-.88-.88c-.393-.642-.393-1.515-.393-3.26V5.2ZM7.867 2h.267c.899 0 1.48.002 1.918.043.419.04.57.107.645.154.18.11.33.26.44.44.047.076.114.226.154.645.042.44.043 1.02.043 1.918v5.6c0 .9-.001 1.48-.043 1.918-.04.42-.107.57-.154.646-.11.18-.26.33-.44.44-.076.046-.226.113-.645.153C9.613 14 9.032 14 8.134 14h-.267C6.97 14 6.388 14 5.95 13.957c-.419-.04-.57-.107-.645-.153-.18-.11-.33-.26-.44-.44-.047-.076-.114-.227-.154-.646-.041-.438-.043-1.019-.043-1.918V5.2c0-.898.002-1.479.043-1.918.04-.419.107-.57.154-.645.11-.18.26-.33.44-.44.076-.047.226-.114.645-.154C6.39 2.002 6.97 2 7.867 2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPhone24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPhone24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M14 6V4h-4v2h4Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 7.8c0-2.619 0-3.928.59-4.89a4 4 0 0 1 1.32-1.32C7.872 1 9.181 1 11.8 1h.4c2.619 0 3.928 0 4.89.59a4 4 0 0 1 1.32 1.32c.59.962.59 2.271.59 4.89v8.4c0 2.619 0 3.928-.59 4.89-.33.538-.782.99-1.32 1.32-.962.59-2.271.59-4.89.59h-.4c-2.619 0-3.928 0-4.89-.59a4 4 0 0 1-1.32-1.32C5 20.128 5 18.819 5 16.2V7.8ZM11.8 3h.4c1.348 0 2.219.002 2.877.065.629.06.854.16.968.23a2 2 0 0 1 .66.66c.07.114.17.34.23.968.063.658.065 1.529.065 2.877v8.4c0 1.348-.002 2.219-.065 2.877-.06.628-.16.854-.23.968a2 2 0 0 1-.66.66c-.114.07-.34.17-.968.23-.658.063-1.529.065-2.877.065h-.4c-1.348 0-2.219-.002-2.877-.065-.629-.06-.854-.16-.968-.23a2 2 0 0 1-.66-.66c-.07-.114-.17-.34-.23-.968C7.002 18.419 7 17.548 7 16.2V7.8c0-1.348.002-2.219.065-2.877.06-.629.16-.854.23-.968a2 2 0 0 1 .66-.66c.114-.07.34-.17.968-.23C9.581 3.002 10.452 3 11.8 3Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconPhone = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPhone(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconPhone16 {...iconProps} />;
        case '24':
            return <IconPhone24 {...iconProps} />;
        default:
            return <IconPhone24 {...iconProps} />;
    }
});
